goog.require('el8.print.scheduleReport');

var el8 = el8 || {};
if (!el8.main) { el8.main = {}; }
el8.main.scheduleReport = {};

el8.main.scheduleReport.init = function(spec) {
    el8.print.scheduleReport.init(spec);
};
